module.exports = __webpack_public_path__ + "img/post6_4.7e9aa5f3.jpeg";